/**
 * Gift cards feature flag. The gift-card admin surface (Sales → Gift Cards,
 * client gift cards, …) ships behind this wall. Default OFF.
 *
 * Mirrors `isSalesTabEnabled` (utils/salesTabFlag.ts). Read at call time so
 * tests can flip `process.env.REACT_APP_GIFT_CARDS_ENABLED` per case.
 */
export function isGiftCardsEnabled(): boolean {
  return process.env.REACT_APP_GIFT_CARDS_ENABLED === "true";
}
